import { render, staticRenderFns } from "./PriorityParentingMatterOrder.vue?vue&type=template&id=bbe1f83e"
import script from "./PriorityParentingMatterOrder.vue?vue&type=script&lang=ts"
export * from "./PriorityParentingMatterOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports